import React, { useState, useEffect, useRef } from 'react';
import { useAuthenticatedFetch } from '../hooks/useAuthenticatedFetch';
import { apiUrl } from '../utils/apiBase';

export default function BroadcastChat({ token }) {
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState('');
  const [open, setOpen] = useState(true);
  const [unreadCount, setUnreadCount] = useState(0);
  const authenticatedFetch = useAuthenticatedFetch();
  const messagesEndRef = useRef(null);

  useEffect(() => {
    if (!token) return;
    const es = new EventSource(apiUrl(`/api/broadcast/chat/${token}`));
    es.onmessage = (e) => {
      try {
        const data = JSON.parse(e.data);
        if (Array.isArray(data)) {
          setMessages(data);
          // Azzeriamo il contatore quando arriva l'array iniziale
          setUnreadCount(0);
        } else {
          setMessages((m) => [...m, data]);
          // Se la chat è chiusa, incrementa il contatore
          if (!open) setUnreadCount((c) => c + 1);
        }
      } catch {}
    };
    return () => es.close();
  }, [token, open]);

  // Scroll automatico solo all'interno della chat, non della pagina
  useEffect(() => {
    const chatContainer = messagesEndRef.current?.parentNode;
    if (chatContainer) {
      chatContainer.scrollTop = chatContainer.scrollHeight;
    }
  }, [messages, open]);

  const send = async () => {
    if (!input.trim()) return;
    await authenticatedFetch(apiUrl(`/api/broadcast/chat/${token}`), {
      method: 'POST',
      body: JSON.stringify({ message: input.trim() })
    });
    setInput('');
  };

  if (!open) {
    return (
      <button
        onClick={() => {
          setOpen(true);
          setUnreadCount(0); // azzera il contatore quando si apre la chat
        }}
        className="absolute right-2 top-2 text-xs bg-black/60 text-white px-2 py-1 rounded flex items-center gap-1"
      >
        <span>Chat</span>
        {unreadCount > 0 && (
          <span className="ml-1 px-2 py-0.5 rounded-full bg-red-600 text-white text-[10px] font-bold min-w-[18px] text-center">
            {unreadCount}
          </span>
        )}
      </button>
    );
  }

  return (
    <div className="absolute top-0 bottom-0 right-0 w-64 bg-black/70 text-white text-xs flex flex-col">
      <div className="p-2 border-b border-gray-700 flex justify-between items-center">
        <span className="font-bold">Chat</span>
        <button onClick={() => setOpen(false)} className="text-sm">✕</button>
      </div>
      <div className="flex-1 overflow-y-auto p-2 space-y-1">
        {messages.map((m) => (
          <div key={m.id}>
            <span className="text-purple-300 mr-1">{m.username}</span>
            <span>{m.text}</span>
          </div>
        ))}
        <div ref={messagesEndRef} />
      </div>
      <div className="p-2 border-t border-gray-700">
        <input
          type="text"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); send(); } }}
          placeholder="Scrivi..."
          className="w-full rounded bg-gray-800 text-white p-1 text-xs"
        />
      </div>
    </div>
  );
}
